<template>
  <div style="margin:20px">
    <FiPageRail title="Vehicle Status History">
      <template #actions>
        <vsm-back-link-button />
      </template>
    </FiPageRail>

    <div v-if="summary" style="margin: 20px 8px 10px">
      <vsm-mobile-filter-chips
        :size="isMobile() ? 'sm' : 'md'"
        :total-format="isMobile() ? 'slash' : 'of'"
        :items-count="items.length"
        :total-count="summary.total_cnt"
        :total-selected="!selected_status && !search_filter"
        :show-search="true"
        :search-filter="search_filter"
        search-placeholder="filter by keyword"
        @clear-filters="clear_history_filters()"
        @update:searchFilter="search_filter = $event"
      >
        <span class="vsm-chip vsm-chip-clickable ready" :class="{ 'vsm-chip-selected': selected_status === 'READY' }" @click="filter_by_status('ready')">Ready</span>
        <span class="vsm-chip vsm-chip-clickable dirty" :class="{ 'vsm-chip-selected': selected_status === 'DIRTY' }" @click="filter_by_status('dirty')">Dirty</span>
        <span class="vsm-chip vsm-chip-clickable cleaned" :class="{ 'vsm-chip-selected': selected_status === 'CLEAN' }" @click="filter_by_status('cleaned')">Clean</span>
        <span class="vsm-chip vsm-chip-clickable washed" :class="{ 'vsm-chip-selected': selected_status === 'WASH' }" @click="filter_by_status('washed')">Washed</span>
        <span class="vsm-chip vsm-chip-clickable out" :class="{ 'vsm-chip-selected': selected_status === 'OUT' }" @click="filter_by_status('out')">Out</span>
        <template #extras>
          <!-- position: relative is required by bootstrap-datetimepicker for dropdown positioning -->
          <span class="vsm-filter-extras" style="position: relative">
            <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
            <date-picker style="font-size: 18px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
            <span>to</span>
            <date-picker style="font-size: 18px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
            <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
            <b-form-select v-if="vehicle_tag_options && vehicle_tag_options.length > 1" v-model="selected_tag" :options="vehicle_tag_options" class="vsm-filter-select"/>
            <b-form-select v-model="selected_vehicle" :options="vehicle_options" style="font-size: 18px; font-weight: bold; width:150px"/>
            <b-button size="sm" v-on:click.prevent="load_data()">Search</b-button>
            <b-button size="sm" v-on:click.prevent="download()">Download</b-button>
          </span>
        </template>
      </vsm-mobile-filter-chips>
    </div>

    <div v-if="summary">
      <b-table :busy="loading" :sticky-header="windowHeight ? windowHeight*.9 + 'px':'80vh'" bordered :items="items" :fields="visibleFields"
               :current-page="currentPage" :sort-compare="tableSortCompare" :style="'font-size:' + summary.font_size + 'px'" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
          </div>
        </template>

        <template slot="notes" slot-scope="row">
          <div style="text-align: left">{{row.item.notes}}</div>
        </template>

        <template slot="vehicle_status" slot-scope="row">
          {{row.item.vehicle_status}}
        </template>
        <template slot="maintenance_status" slot-scope="row">
          {{display_maint_status(row.item.maintenance_status)}}
        </template>
        <template slot="confirmed_status" slot-scope="row">
          <div v-if="row.item.confirmed_time" style="font-weight: bold; background-color: lightgreen">
            {{row.item.confirmed_time | formatDateTimeSmall}}
          </div>
          <div v-else-if="row.item.confirmed_status == 'sent'" style="font-weight: bold; background-color: lightsalmon">
            {{row.item.confirmed_sent_time | formatDateTimeSmall}}
          </div>
        </template>
        <template slot="processed_time" slot-scope="row">
          {{row.item.processed_time | formatDateTimeSmall}}
        </template>
        <template slot="last_dirty_time" slot-scope="row">
          {{row.item.last_dirty_time | formatDateTimeSmall}}
        </template>
        <template slot="last_cleaned_time" slot-scope="row">
          {{row.item.last_cleaned_time | formatDateTimeSmall}}
        </template>
        <template slot="last_washed_time" slot-scope="row">
          {{row.item.last_washed_time | formatDateTimeSmall}}
        </template>
        <template slot="last_ready_time" slot-scope="row">
          {{row.item.last_ready_time | formatDateTimeSmall}}
        </template>
        <template slot="detailed_date" slot-scope="row">
          {{row.item.detailed_date | formatDateTimeSmall}}
        </template>
        <template slot="wrapped_date" slot-scope="row">
          {{row.item.wrapped_date | formatDateTimeSmall}}
        </template>
        <template slot="dump_date" slot-scope="row">
          {{row.item.dump_date | formatDateTimeSmall}}
        </template>
        <template slot="last_out_time" slot-scope="row">
          {{row.item.last_out_time | formatDateTimeSmall}}
        </template>
        <template slot="last_returned_time" slot-scope="row">
          {{row.item.last_returned_time | formatDateTimeSmall}}
        </template>

      </b-table>
      <b-row v-if="items.length > 10">
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import {api_url, get_tag_list, get_vehicle_list, get_vehicle_status_history} from '../networking/apis'
import {mapState} from "vuex";
import moment from 'moment';
import datetime from 'vuejs-datetimepicker';
import {justDate} from "../helpers/dates";
import axios from "axios";
import { displayMaintStatus } from '../utils/vsm_fields'
import VsmMobileFilterChips from './vsm_mobile_filter_chips.vue'
import VsmBackLinkButton from './VsmBackLinkButton.vue'

export default {
  name: 'vehicle_status_history',
  components: {
     datetime,
     VsmMobileFilterChips,
     VsmBackLinkButton,
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      windowHeight: window.innerHeight,
      details_fromDate: justDate(moment().add(-1, 'days')),
      details_toDate: justDate(moment()),
      selected_tag: '',
      selected_vehicle: '',
      selected_status:'',
      search_filter: '',
      vehicle_options: [ { value: '', text: 'All' }],
      updating: false,
      items: [],
      items_full: [],
      summary: null,
      loading: false,
      vehicle_tag_options: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      alert: {
        show: false,
        message: '',
        variant: ''
      },
      status_options: [
        { value: '', text: 'All' },
        { value: 'READY', text: 'READY' },
        { value: 'DIRTY', text: 'DIRTY' },
        { value: 'CLEAN', text: 'CLEAN' },
        { value: 'WASH', text: 'WASHED' },
        { value: 'OUT', text: 'OUT' },
      ],
      status_chip_map: {
        ready: 'READY',
        dirty: 'DIRTY',
        cleaned: 'CLEAN',
        washed: 'WASH',
        out: 'OUT',
      },
      fields: [
        { key: 'vehicle_name', label: 'Vehicle', sortable: true, visible: true, thStyle: { width: "110px" }},
        { key: 'processed_time', label:'Update At', visible: true, sortable: true, thStyle: { width: "140px" }},
        { key: 'updated_by', label:'Updated By', visible: true, sortable: true, thStyle: { width: "140px" }},
        { key: 'vehicle_status', label:'Veh Status', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'maintenance_status', label:'Maint Status', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'booking_hash', label:'Booking', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'last_dirty_time', label:'Dirty', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'confirmed_status', label: 'Driver Confirm', sortable: true, visible: true, thStyle: { width: "120px" }},
        { key: 'confirmed_by', label: 'Confirmed By', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_cleaned_time', label:'Cleaned', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_cleaned_number', label:'Cleaned #', sortable: true, visible: true, thStyle: { width: "130px" }},
        { key: 'last_washed_time', label:'Washed', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_washed_number', label:'Washed #', sortable: true, visible: true, thStyle: { width: "130px" }},
        { key: 'last_ready_time', label:'Ready', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'last_returned_time', label: 'Last Return', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'dump_date', label:'Dump Date', visible: false, sortable: true, thStyle: { width: "140px" }},
        { key: 'detailed_date', label:'Detail Date', visible: false, sortable: true, thStyle: { width: "140px" }},
        { key: 'wrapped_date', label:'Wrapped Date', visible: false, sortable: true, thStyle: { width: "140px" }},
        { key: 'odometer', label:'Odometer', visible: false, sortable: true, thStyle: { width: "100px" }},
        { key: 'fuel_level', label:'Fuel', visible: false, sortable: true, thStyle: { width: "100px" }},
        { key: 'def_level', label:'DEF', visible: false, sortable: true, thStyle: { width: "100px" }},
        { key: 'wheelchair', label: 'WC', sortable: true, thStyle: { width: "75px" }},
        { key: 'stayanddo', label: 'S&D', sortable: true, thStyle: { width: "75px" }},
        { key: 'tote', label: 'Tote', sortable: true, thStyle: { width: "110px" }},
        { key: 'notes', label: 'Notes', sortable: true, visible: true, thStyle: { width: "220px" }},
      ],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(360, 'days'),
        maxDate: moment().add(0, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      }
    }
  },
  async created() {
    this.fields_all = this.fields
    await this.check_features()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    isMobile() {
      return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },
    display_maint_status(status) {
      const features = this.user && this.user.features && this.user.features[this.user.tenant]
      return displayMaintStatus(status, features && features.vehicle_status_management_dvir_combined)
    },
    async check_features() {
      this.items = []
      this.summary = null
      this.load_tags()
      this.load_vehicles()
      await this.load_data()
    },
    async load_vehicles() {
      const {value: {data = []}} = await get_vehicle_list(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
      this.vehicle_options = data
    },
    async load_tags() {
      const {value: {data = []}} = await get_tag_list(this.user.tenant)
      this.vehicle_tag_options = data
    },
    showAlert(msg, variant, autoclose) {
      this.alert.show = true
      this.alert.message = msg
      this.alert.variant = variant
      autoclose
          ? setTimeout(() => this.closeAlert(), autoclose)
          : null
    },
    closeAlert() {
      this.alert.show = false
      this.alert.message = ''
      this.alert.variant = ''
    },
    tableSortCompare(aRow, bRow, key) {
      if (key == 'next_mvmt_delta') {
        return aRow['next_mvmt_ms'] - bRow['next_mvmt_ms']
      }
      return false;
    },
    async load_data() {
      this.loading = true
      try {
        const {value: { data = [] } } = await get_vehicle_status_history(this.user.tenant, this.selected_tag, this.selected_vehicle, this.search_filter, this.selected_status, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.filter_items()
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
      this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${api_url}bookings/reports/vehiclestatus/history/download`,
          {
            tenant: this.user.tenant,
            tagName: this.selected_tag,
            vehicleName: this.selected_vehicle,
            filter: this.search_filter,
            statusFilter: this.selected_status,
            startDate: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            endDate: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `vsm-history-${this.details_fromDate}-${this.details_toDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger')
      })
    },
    clear_history_filters() {
      this.selected_status = ''
      this.search_filter = ''
      this.load_data()
    },
    filter_by_status(chipKey) {
      if (chipKey == null) {
        this.selected_status = ''
      } else {
        const val = this.status_chip_map[chipKey]
        this.selected_status = this.selected_status === val ? '' : val
      }
      this.load_data()
    },
    filter_items() {
      this.items = this.items_full
      if (this.search_filter != '') {
        this.items = this.items.filter(item => (this.contains(item.vehicle_name, this.search_filter) || this.contains(item.updated_by, this.search_filter) || this.contains(item.vehicle_status, this.search_filter) || this.contains(item.notes, this.search_filter)))
      }
    },
    contains(val1, val2) {
      if (val1 != null && val2 != null) {
        return String(val1).toLowerCase().indexOf(String(val2).toLowerCase()) != -1;
      }
      return false;
    },

},
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    visibleFields() {
      var custom_fields = null;

      if (this.summary && this.summary.visible_history_fields)
        custom_fields = this.summary.visible_history_fields;

      if (custom_fields != null) {
        custom_fields = "vehicle_name," + custom_fields;
        let new_fields = []
        for (let visible_field of custom_fields.split(",").map(f => f.trim())) {
          let found_field = this.fields.filter(field => visible_field == field.key)
          if (found_field.length > 0) {
            new_fields.push(found_field[0]);
          }
        }
        return new_fields;
      } else
        return this.fields
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    selected_tag() {
      if (this.selected_tag != '')
        this.selected_vehicle = ''
    },
    selected_vehicle() {
      if (this.selected_vehicle != '')
        this.selected_tag = ''
    },
    search_filter() {
      this.filter_items()
    },
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      if (moment(this.details_fromDate, 'MM-DD-YYYY') > moment(this.details_toDate, 'MM-DD-YYYY'))
        this.details_toDate = this.details_fromDate
    }
  }
}
</script>

<style scoped>

</style>

